// extracted by mini-css-extract-plugin
export default {"card":"FakeDetection_card__LhUC-"};